import { render } from "./RealRegEdit.vue?vue&type=template&id=6d69bf1e&scoped=true"
import script from "./RealRegEdit.vue?vue&type=script&lang=js"
export * from "./RealRegEdit.vue?vue&type=script&lang=js"

import "./RealRegEdit.vue?vue&type=style&index=0&id=6d69bf1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d69bf1e"]])

export default __exports__